import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.406}
    height={25.988}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 39889 40802"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#2b2a29}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974337281328">
        <path
          d="M11569 29154c60 246 19 1269 19 1601 0 475 55 2944-65 3210-175 388-856 371-965-132-62-291-18-1261-18-1626 0-479-65-2947 72-3213 188-366 829-376 957 160zM34091 29228c64-550 712-645 941-293 164 251 102 1151 102 1521 0 579 30 2899-5 3270-56 570-690 659-940 298-171-245-100-1149-100-1520l2-3276z"
          className="fil0"
        />
        <path
          d="M10045 25498v-229c2-645 99-1136 444-1485 328-331 829-452 1448-452l16310 8c1922-1 1995 881 1912 2388-1602 19-1814 9-3417 9-503 0-2009-75-2398 22-331 81-459 310-464 712-10 840-26 9390 15 9668 55 376 287 521 686 527 801 14 1633-31 2423-14 462 10 515 224 610 602 84 337 182 623 314 916 481 1078 1371 1831 2624 2214 2467 753 4848-776 5420-3225 36-153 38-412 153-493 889 0 1794 16 2681-1 1014-20 847-316 847-1815v-8042c2-1178-77-1078-1591-1078-954 0-4726 51-5359-38-123-1340 217-2694-496-3755-661-983-1605-1120-3119-1121-763 0-7164 60-7726-42l-5-12749c2251-134 4662-936 5664-2847 343-654 679-1445 959-2131 112-275 463-2299 229-2608-207-273-927-206-1341-206H12993c-2114-47-782 3904-228 5029 1896 3851 5801 2113 6027 3082 69 299 12 7876 12 9378 0 947 66 2176-32 3086-557 49-2663 9-3461 9h-4245c-1488 0-2436 110-3112 1128-632 951-454 2492-454 3785l-4775 7c-2259 1-2493-260-2492 1071v8340c0 282-34 907 49 1139 123 340 432 383 841 379l2386-3c409 45 390 343 483 719 888 3561 5809 4431 7802 1102 157-262 268-508 378-815 109-305 163-678 262-957 428-113 2145-33 2728-49 495-11 770-18 826-534 55-525 10-6041 10-6865 0-918 6-1837 1-2755-5-956-383-779-1954-779-982 0-3367 50-4000-11v-221zm16071 9366-11-7313 11331-8 14 7310-11334 11zM2450 27535l11331-8 13 7310-11333 11-11-7313zm7595-2037c0 26 0 48 0 0zm19238 11492 4969-7c17 638-469 1332-758 1567-1065 869-2420 902-3427 5-281-250-803-943-784-1565zM15031 3479c-81-181-272-535-313-721l10712-1-609 1389c-207 462-397 929-866 1147-580 266-3063 172-3878 172-768 0-3357 92-3884-131-583-247-814-1074-1162-1855zM5624 36990l4969-7c17 638-469 1332-758 1567-1064 869-2420 902-3426 5-282-250-804-943-785-1565z"
          className="fill"
          style={{
            // stroke: "#2b2a29",
            strokeWidth: 452.176,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
